/**
 * Copy e descritores declarativos do modal de solicitação de reabertura.
 * Espelha o padrão de textos de `REOPEN_AUDIT_MODAL`.
 */
export const SALE_REOPEN_REQUEST_MODAL = {
  title: "Solicitar reabertura de venda",
  description: "",
  cancel: "Cancelar",
  confirm: "Enviar",
  confirmLoading: "Enviando...",
  recipient: {
    id: "reopen-recipient",
    label: "Destinatário *",
    placeholder: "Selecione um destinatário",
    loadingLabel: "Carregando destinatários...",
    retryLabel: "Tentar novamente",
    errorFallback: "Erro ao carregar destinatários",
  },
  reason: {
    id: "reopen-reason",
    label: "Observação (opcional)",
    placeholder: "Descreva o motivo ou o contexto da solicitação...",
  },
};

/** Copy do diálogo de resultado (sucesso/erro) após POST request-reopen. */
export const SALE_REOPEN_REQUEST_RESULT = {
  successTitle: "Solicitação enviada",
  errorTitle: "Falha ao enviar",
  successMessage: "Solicitação de reabertura enviada com sucesso",
  errorMessage: "Erro ao enviar solicitação de reabertura",
  confirm: "OK",
};

/** Status possíveis do campo destinatário (config-driven render). */
export const RECIPIENT_FIELD_STATUS = {
  loading: "loading",
  error: "error",
  ready: "ready",
};
